import { render, staticRenderFns } from "./QuadroHorarioProfessorPage.vue?vue&type=template&id=eab2a374&scoped=true"
import script from "./QuadroHorarioProfessorPage.vue?vue&type=script&lang=js"
export * from "./QuadroHorarioProfessorPage.vue?vue&type=script&lang=js"
import style0 from "./QuadroHorarioProfessorPage.vue?vue&type=style&index=0&id=eab2a374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab2a374",
  null
  
)

export default component.exports